// Product pages populate this data through the managed availability API.
// Empty availability must never fall back to retired Classic ASP endpoints.
function buildTimeOptions(dateStr) {
    var sessions = typeof availabilitySessions !== 'undefined' && Array.isArray(availabilitySessions) ? availabilitySessions : [];
    var select = document.createElement('select');
    var hasSelected = false;
    sessions.forEach(function (session) {
        if (!session.startTimeLocal || session.startTimeLocal.substring(0, 10) !== dateStr) return;
        var time = session.startTimeLocal.substring(11, 16);
        var seats = Number(session.seatsAvailable);
        if (!Number.isFinite(seats)) return;
        var option = document.createElement('option');
        option.value = String(session.id) + '-' + time;
        option.disabled = seats <= 0;
        option.textContent = time + '\u00a0\u00a0\u00a0' + (option.disabled ? '(Fully Booked)' : '(' + seats + ' available)');
        if (!option.disabled && !hasSelected) {
            option.setAttribute('selected', 'selected');
            hasSelected = true;
        }
        select.appendChild(option);
    });
    return select.innerHTML;
}

function instantBookv2(date) {
    var html = buildTimeOptions(date);
    $('.preferredTime').empty().append(html);
    $('.timeSelection').toggleClass('hidden', !html);
}
